<div
    class='agpr-block agpr-chartBlock agpr-contextMenu-parent'
    [id]="id"
    [ngClass]="{
        'agpr-chartBlock--preview': preview
    }"
    role="group"
    [attr.aria-label]="chart?.metadata?.titleText + ' Chart. ' + ('Reports.chart.keyboardNavigationDescription' | localize)"
>
    <div
        *ngIf="actionable && !preview"
        class="agpr-block-dragHandle"
        role="button"
        (keydown)="dragKeydown($event)"
        tabindex="0"
        [attr.aria-label]="'Reports.chart.dragHandle.ariaLabel' | localize"
    >
        <span class="fa-kit fa-agpr-drag-drop"></span>
    </div>
    <ul
        *ngIf="actionable && !preview"
        class="agpr-contextMenu"
        role="menu"
        [attr.aria-describedby]="id + '_errors' + ' ' + id + '_dataSource_error' + ' ' + id + '_prominence_error'"
    >
        <li
            role="menuitem"
            class="agpr-contextMenu-menuItem"
        >
            <agpr-button
                icon="fa-regular fa-duotone fa-pen"
                [id]="id + '.edit'"
                (click)="onAction('edit')"
                tooltip="Reports.chartSetupDialog.editHeading"
                tooltipPosition="top"
                [style]="buttonTypes.contextMenu"
            >
            </agpr-button>
        </li>
        @if (block.canAnnotate) {
            <li
                role="menuitem"
                class="agpr-contextMenu-menuItem"
            >
                <agpr-button
                    [id]="id + '_annotate'"
                    [style]="buttonTypes.contextMenu"
                    icon="fa-kit-duotone fa-agpr-annotate"
                    tooltip="Reports.chartSetupDialog.annotate"
                    tooltipPosition="top"
                    (click)="onAction('annotate')"
                ></agpr-button>
            </li>
        }
        <li
            role="menuitem"
            class="agpr-contextMenu-menuItem"
        >
            <agpr-button
                icon="fa-regular fa-duotone fa-layer-plus"
                [id]="id + '.duplicate'"
                (click)="onAction('duplicate')"
                [tooltip]="'Reports.chartSetupDialog.duplicate'"
                tooltipPosition="top"
                [style]="buttonTypes.contextMenu"
            ></agpr-button>
        </li>
        <li
            role="menuitem"
            class="agpr-contextMenu-menuItem"
        >
            <agpr-chart-export-menu
                class="agpr-chartBlock-reportExportIcon"
                [id]="id + '.export'"
                iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                [supportedFormats]="supportedExportingFormats"
                (exportMenuClicked)="chartExport($event)"

            >
            </agpr-chart-export-menu>
        </li>
        <li
            role="menuitem"
            class="agpr-contextMenu-menuItem"
        >
            <agpr-button
                icon="fa-regular fa-trash-can"
                class="agpr-block-contextButton agpr-block-contextButton--topRight"
                [id]="id + '.delete'"
                (click)="onAction('delete')"
                [tooltip]="'Reports.chartSetupDialog.deleteChart'"
                tooltipPosition="top"
                [style]="buttonTypes.contextMenu"
            >
            </agpr-button>
        </li>
    </ul>
    <div
        class="agpr-block-content agpr-chartBlock-content"
    >
        <div
            *ngIf="!renderable"
            class='agpr-chartBlock-placeholder'
        >
            <div class="agpr-chartBlock-placeholder-topRow">
              <span class="fa agpr-chartBlock-placeholderIcon {{ block.type.icon }}" aria-hidden="true"></span>
              <span class="agpr-chartBlock-placeholderLabel">{{ block.type.label | localize }}</span>
            </div>
            <div class="agpr-block-chartPlaceholder-body">
                <ng-template
                  #customPlaceholderTemplate
                  let-prefixText="prefixText"
                  let-linkText="linkText"
                  let-linkUrl="linkUrl"
                >
                  <span>{{ prefixText }}<a target="_blank" href="{{ linkUrl }}">{{ linkText }}</a></span>
                </ng-template>
                <ng-container
                  *ngIf="showExternalDataCustomPlaceholder"
                >
                  <ng-container
                    *ngTemplateOutlet="customPlaceholderTemplate; context: externalDataCustomPlaceholderConfig;"
                  >
                  </ng-container>
                </ng-container>
            </div>
            <div
                *ngIf="noDataSource"
                class="agpr-chartBlock-noChartMessage"
            >
                <agpr-message
                    [id]="id + '_placeholder_dataSource_error'"
                    *ngIf="!preview"
                    [severity]="messageSeverityEnum.error"
                >
                    {{ 'Reports.error.folderRemoved' | localize }}
                </agpr-message>
                <agpr-message
                    [id]="id + '_placeholder_preview_dataSource_info'"
                    *ngIf="preview"
                    [severity]="messageSeverityEnum.info"
                >
                    {{ 'Reports.chart.noDataSource' | localize }}
                </agpr-message>
            </div>
        </div>
        <!-- chart-->
        <ng-container *ngIf="renderable">
            <div
                *ngIf="preview"
                class="agpr-chartBlock-watermark"
            >
                {{ 'Reports.chart.sampleData' | localize }}
            </div>

            <ng-container *ngIf="chart || am5Chart">
                <!-- the metadata only renders when the chart fails to get data, otherwise metadata is rendered via amcharts -->
                <div
                    *ngIf="noData"
                    class="agpr-chartBlockMetadata"
                >
                    <div
                        class="agpr-chartBlockMetadata-title"
                    >
                        {{ displayElement?.title }}
                    </div>
                    <div class="agpr-chartBlockMetadata-subtitleGroup">
                        <div
                            class="agpr-chartBlockMetadata-dateRange"
                        >
                            {{ displayElement?.dateRangeLabel }}
                        </div>
                        <div
                            class="agpr-chartBlockMetadata-source"
                        >
                            {{ displayElement?.series[0]?.label }}
                        </div>
                    </div>
                </div>
                <div
                    *ngIf="!(isProminenceChart && !hasProminenceProvision)"
                    class="agpr-chartBlock-chart"
                    [ngClass]="{'agpr-chartBlock-chart--noData': noData }"
                >
                    <agpr-am5-chart
                        #am5ChartComponent
                        [ngClass]="{'agpr-chartBlock--hasAnnotation': am5Chart.settings.chartAnnotations}"
                        [chart]="am5Chart"
                        [series]="reportSeries"
                        (noData)="updateNoData($event)"
                        (tooltipLinkClick)="openDrilldown($event)"
                    ></agpr-am5-chart>
                </div>

                <div
                    *ngIf="missingDataSource"
                    class="agpr-chartBlock-noChartMessage"
                >
                    <agpr-message
                        *ngIf="!preview"
                        [id]="id + '_missingDataSource_error'"
                        [severity]="messageSeverityEnum.error"
                        [closeable]="true"
                    >
                        {{ 'Reports.error.dataSourceNoLongerAvailable.some' | localize }}
                    </agpr-message>
                    <agpr-message
                        *ngIf="preview"
                        [id]="id + '_preview_missingDataSource_info'"
                        [severity]="messageSeverityEnum.info"
                        [closeable]="true"
                    >
                        {{ 'Reports.chart.noDataSource' | localize }}
                    </agpr-message>
                </div>
                <div
                    *ngIf="noData"
                    class="agpr-chartBlock-noChartMessage"
                >
                    <agpr-message
                        [id]="id + '_dataLoadFailure'"
                        [severity]="messageSeverityEnum.error"
                    >
                        {{ 'Reports.chart.dataLoadFailure' | localize }}
                    </agpr-message>
                </div>
            </ng-container>

            <div
                *ngIf="!am5Chart"
                class="agpr-chartBlock-noChartMessage"
            >
                <agpr-message
                    [id]="id + '_dataSource_error'"
                    [severity]="messageSeverityEnum.info"
                >
                    {{ 'Reports.chart.noDataSource' | localize }}
                </agpr-message>
            </div>

            <div
                *ngIf="isProminenceChart && (prominenceStatus !== prominenceStatuses.DONE) && hasProminenceProvision"
                class="agpr-chartBlock-noChartMessage"
            >
                <agpr-message [severity]="prominenceStatus === prominenceStatuses.FAILED ? 'error' : 'warning'" [id]="id + '_prominence_error'">
                    <ng-container *ngIf="prominenceStatus === prominenceStatuses.ONGOING || prominenceStatus === prominenceStatuses.PENDING">
                        {{'AccountPreferences.prominence.disclaimer.cannotEdit' | localize}}
                    </ng-container>
                    <ng-container *ngIf="prominenceStatus === prominenceStatuses.FAILED">
                        {{'AccountPreferences.prominence.disclaimer.contactEngineering' | localize}}
                    </ng-container>
                </agpr-message>
            </div>
        </ng-container>
    </div>
    <div class="agpr-chartBlock-noProminence" *ngIf="isProminenceChart && !hasProminenceProvision">
        <agpr-message severity="info" [id]="id + '_prominence_error'">
            <div [innerHTML]="'AccountPreferences.prominence.disclaimer.noProminence' | localize: { contactLink: noProminenceContactLink }"></div>
        </agpr-message>
    </div>
    <div class="agpr-block-hoverBorder"></div>
    <!-- resize icons -->
    <button
        class="gridster-item-resize gridster-item-resize--right"
        (keydown)="resizeKeydown($event)"
        [attr.aria-label]="'Dashboard.chart.resizeChart'"
    >
        <span
            class="gridster-item-icon--bottomRight fa-kit fa-agpr-resize-diagonal"
            role="img"
        ></span>
    </button>
</div>

<ul *ngIf="block.errors?.length > 0" class="agpr-blockError" [id]="id + '_errors'">
    <li *ngFor="let error of block.errors">
        <agpr-form-message>
            {{ error }}
        </agpr-form-message>
    </li>
</ul>
